import { InjectionToken } from '@angular/core';

export const SSR_CONFIG = new InjectionToken<Object>('SSR_CONFIG');
export const SSR_SITEMAP = new InjectionToken<Object>('SSR_SITEMAP');
